import { parseJwt } from '@/utils/jwt';
import { fetchReboostClosesAt } from '@/utils/helpers/reboostWindow';
import { startTimeTicker } from '@/utils/helpers/relativeTime';

function checkPaymentRedirect(context) {
  const isReactNative = window.originalPostMessage;
  if (isReactNative) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const q = urlParams.get('q');

  if (!q) {
    return;
  }

  const { productType, propositionId } = parseJwt(q);

  if (productType == 'extrasynlighet' && !isReactNative) {
    const propositions = context.rootGetters['myPropositions/propositions'];
    const proposition = propositions.find(
      x => x.propositionId == propositionId
    );

    if (!proposition) {
      return;
    }

    context.commit('setProposition', proposition);
    context.commit('setVisible', true);
  }
}

// Consumables A/B: reads the ad's re-boost window for the Boost button and
// answers whether it is open now. The ticker makes the getter close it.
async function loadReboostWindow({ commit }, propositionId) {
  const closesAt = await fetchReboostClosesAt(propositionId);
  commit('setReboostClosesAt', closesAt);
  if (closesAt === null) return false;
  startTimeTicker();
  return closesAt > Date.now();
}

export default { checkPaymentRedirect, loadReboostWindow };
